 <template>
  <v-container fluid v-if="getPermission('setting:view')">
    <v-layout>
      <v-flex>
        <h3
          class="font-weight-700 mb-4 font-size-24 custom-headline color-custom-blue"
        >
          Claim Category
        </h3>
      </v-flex>
      <div>
        <v-btn
          depressed
          class="custom-grey-border custom-bold-button"
          v-on:click="goBack"
        >
          <v-icon small left>mdi-keyboard-backspace</v-icon>
          Back
        </v-btn>
      </div>
    </v-layout>
    <v-card-title class="headline grey lighten-4">
      <v-row align="center" class="px-2">
        <v-col cols="auto" class="py-0 pr-10">
          <h3 class="font-weight-700 custom-headline color-custom-blue mb-0">
            Claim Category & Sub-Category
          </h3>
        </v-col>

        <v-col v-if="false" class="py-0 px-2">
          <v-text-field
            v-model="search"
            dense
            outlined
            clearable
            hide-details
            color="cyan"
            prepend-inner-icon="mdi-magnify"
            placeholder="Search by category / sub-categories"
            @input="onSearch"
          />
        </v-col>
        <v-spacer></v-spacer>

        <template v-if="getPermission('setting:update')">
          <v-col cols="auto" class="py-0 pl-2">
            <v-btn
              small
              color="#00BCD4"
              class="font-size-16 font-weight-700 white--text"
              @click="openCategoryDialog"
            >
              <v-icon left color="white" size="18">mdi-plus-circle</v-icon>
              Add Category
            </v-btn>
          </v-col>
        </template>
      </v-row>
    </v-card-title>

    <v-spacer></v-spacer>
    <ListingTable
      :key="currentPage"
      :columnCount="6"
      :claimCategories="claimCategories"
    >
      <template v-slot:thead>
        <thead>
          <tr>
            <th class="simple-table-th">#</th>
            <th class="simple-table-th">Category</th>
            <th class="simple-table-th">Max Amount</th>
            <!-- <th class="simple-table-th">Interval</th> -->
            <th class="simple-table-th">Sub-Categories</th>
            <th class="simple-table-th">Action</th>
          </tr>
        </thead>

        <tbody>
          <template v-if="claimCategories.length">
            <tr
              v-for="(item, index) in claimCategories"
              :key="item.id"
              class="alternate-listing-row"
            >
              <td class="simple-table-td pl-4">
                {{ rowsOffset + index + 1 }}
              </td>

              <td class="simple-table-td pl-4">
                <div class="d-flex align-center">
                  <v-chip
                    class="color-indicator mr-2"
                    small
                    label
                    :color="item.color || '#00BCD4'"
                  ></v-chip>

                  <span class="text-capitalize">
                    {{ item.claim_type || "No Name" }}
                  </span>
                </div>
              </td>

              <td class="simple-table-td pl-4">
                <v-chip small color="red" class="white--text">
                  {{ item.max_amount ?? "-" }}
                </v-chip>
              </td>

              <!--    <td class="simple-table-td pl-4">
                {{ item.interval || "-" }}
              </td>
 -->
              <td class="simple-table-td pl-4">
                <v-chip small outlined color="primary">
                  {{ item.subcategories?.length || 0 }} items
                </v-chip>
              </td>

              <td class="simple-table-td pl-4">
                <div class="d-flex align-center">
                  <v-avatar
                    size="20"
                    color="green"
                    class="mr-2"
                    @click="openSubCategoryPopup(item)"
                  >
                    <v-icon color="white" size="14">mdi-plus</v-icon>
                  </v-avatar>

                  <v-icon
                    color="cyan"
                    size="20"
                    class="mr-2"
                    @click="editCategory(item)"
                  >
                    mdi-pencil
                  </v-icon>

                  <v-icon color="red" size="20" @click="deleteCategory(item)">
                    mdi-delete
                  </v-icon>
                </div>
              </td>
            </tr>
          </template>

          <template v-else>
            <tr>
              <td colspan="6">
                <p
                  class="m-0 row-not-found text-center font-weight-500 font-size-16"
                >
                  <img
                    :src="$assetURL('media/error/empty.png')"
                    class="row-not-found-image"
                  />
                  Uhh... No categories found.
                </p>
              </td>
            </tr>
          </template>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="6" class="pa-0">
              <v-row
                align="center"
                class="px-4 py-2"
                style="border-top: 1px solid #e0e0e0"
              >
                <v-col cols="12" md="6">
                  <p class="m-0 listing-footer-count font-weight-500">
                    SHOWING
                    {{ rowsOffset + 1 }}
                    TO
                    {{ Math.min(rowsOffset + itemsPerPage, totalRows) }}
                    OF {{ totalRows }} ENTRIES
                  </p>
                </v-col>

                <v-col cols="12" md="6" class="d-flex justify-end">
                  <v-pagination
                    v-model="currentPage"
                    :length="totalPages"
                    total-visible="5"
                    color="cyan"
                    class="custom-pagination"
                    @input="handlePageChange"
                  />
                </v-col>
              </v-row>
            </td>
          </tr>
        </tfoot>
      </template>
    </ListingTable>

    <Dialog :common-dialog="categoryDialog" :dialog-width="750">
      <template v-slot:title>
        {{ isEdit ? "Edit" : "Add" }} Claim Category
      </template>

      <template v-slot:body>
        <v-form ref="categoryForm" v-model="formValid" lazy-validation>
          <v-container fluid>
            <v-row>
              <v-col md="12">
                <label class="my-auto fw-500 required mb-1">
                  <span>Claim Category</span>
                </label>

                <v-text-field
                  v-model="categoryPayload.claim_type"
                  placeholder="Enter claim category name"
                  dense
                  filled
                  solo
                  flat
                  maxlength="50"
                  hide-details="auto"
                  color="cyan"
                />

                <div
                  class="d-flex justify-end align-center text-caption red--text text--darken-1 w-100"
                >
                  {{ categoryPayload.claim_type?.length || 0 }} / 50
                </div>
              </v-col>

              <v-col md="6">
                <label class="my-auto fw-500 required mb-1">Max Amount </label>
                <v-text-field
                  v-model="categoryPayload.max_amount"
                  type="number"
                  dense
                  filled
                  solo
                  flat
                  placeholder="Enter max amount"
                  color="cyan"
                  @keypress="validateNumber($event)"
                />
              </v-col>

              <v-col v-if="false" md="6">
                <label class="my-auto fw-500 required mb-1">Interval</label>
                <v-select
                  v-model="categoryPayload.interval"
                  :items="['Monthly', 'Annually']"
                  dense
                  filled
                  solo
                  flat
                  placeholder="Select interval"
                  color="cyan"
                />
              </v-col>

              <v-col md="6">
                <label class="my-auto fw-500 mb-1">Color</label>
                <v-color-picker
                  v-model="categoryPayload.color"
                  :swatches="swatches"
                  show-swatches
                  hide-canvas
                  hide-inputs
                  swatches-max-height="100"
                  elevation="10"
                />
              </v-col>

              <v-col v-if="false" md="6">
                <label class="my-auto fw-500 required mb-1"
                  >Approval Roles</label
                >
                <v-select
                  v-model="categoryPayload.approval_roles"
                  placeholder="Select Approval Role"
                  :items="approvalRoles"
                  item-text="name"
                  item-value="id"
                  dense
                  filled
                  solo
                  flat
                  multiple
                  chips
                  small-chips
                  deletable-chips
                  color="cyan"
                />
              </v-col>

              <v-col md="12">
                <div class="d-flex justify-space-between align-center mb-2">
                  <label color="#24326D" class="fw-900 text-h6"
                    >Sub-categories</label
                  >
                  <v-btn
                    small
                    color="green"
                    class="white--text"
                    @click="addSubCategoryField"
                  >
                    <v-icon left small>mdi-plus</v-icon>
                    ADD SUB-CATEGORY FIELD
                  </v-btn>
                </div>
                <v-card outlined>
                  <div
                    v-if="
                      !categoryPayload.subcategories ||
                      categoryPayload.subcategories.length === 0
                    "
                    class="text-center py-6 text-grey"
                  >
                    <v-icon size="36" color="grey">mdi-folder</v-icon>
                    <p class="m-0">no sub-categories added yet</p>
                  </div>

                  <v-simple-table v-else dense>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Subcategory Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(sub, idx) in categoryPayload.subcategories"
                        :key="idx"
                        :style="{
                          backgroundColor:
                            idx % 2 === 0 ? '#f5f5f5' : '#ffffff',
                        }"
                      >
                        <td>
                          <v-icon color="cyan" small>mdi-circle</v-icon>
                        </td>

                        <td>
                          <v-text-field
                            v-model="sub.name"
                            dense
                            solo
                            flat
                            outlined
                            hide-details="auto"
                            maxlength="25"
                            counter
                            :counter-value="(sub.name || '').length"
                            :placeholder="`Subcategory ${idx + 1}`"
                            class="transparent-input"
                            @input="limitSubCategoryName(sub, $event)"
                          />
                        </td>

                        <td class="text-center">
                          <v-icon
                            color="red"
                            small
                            class="cursor-pointer"
                            @click="removeSubCategory(idx)"
                          >
                            mdi-close
                          </v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </template>

      <template v-slot:action>
        <v-btn
          depressed
          :disabled="dataLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="categoryDialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          depressed
          :loading="dataLoading"
          :disabled="dataLoading || !formValid"
          color="cyan white--text"
          class="mx-2 custom-bold-button"
          @click="saveCategory"
        >
          Save Category
        </v-btn>
      </template>
    </Dialog>

    <Dialog
      :common-dialog="subCategoryDialog"
      :dialog-width="540"
      class="mr-2 py-2"
    >
      <template v-slot:title>
        <v-row class="align-center">
          <v-icon size="25" color="green" class="mr-2 px-2">mdi-plus</v-icon>
          <span class="font-weight-700">Add New Sub-category</span>
        </v-row>
      </template>

      <template v-slot:body>
        <v-form ref="subCategoryForm" v-model="subFormValid" class="px-4 py-2">
          <v-row>
            <v-col cols="12">
              <label class="text-subtitle-1 font-weight-medium mb-1"
                >Sub-Category</label
              >
              <v-text-field
                style="border: 0.5px solid grey"
                v-model="subCategoryPayload.name"
                placeholder="Type new sub-category..."
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label
                class="text-subtitle-1 font-weight-medium mb-1 px-2 py-2"
                style="
                  display: inline-block;
                  width: 100%;
                  height: 40px;
                  background-color: #fff0e0;
                  line-height: 26px;
                  font-size: 16px;
                "
              >
                <v-icon color="#FB8C00" size="20" class="mr-2">
                  mdi-information
                </v-icon>
                This sub-category will be added to:

                <strong class="text-capitalize">{{
                  selectedCategory?.claim_type
                }}</strong>
              </label>
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template v-slot:action>
        <v-row justify="end" class="px-2 pb-1">
          <v-btn text color="grey" @click="subCategoryDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="green"
            class="white--text ml-2"
            @click="saveSubCategory"
          >
            Add Sub-category
          </v-btn>
        </v-row>
      </template>
    </Dialog>

    <DeleteDialog :delete-dialog="deleteCategoryDialog">
      <template v-slot:title>Delete Category</template>
      <template v-slot:text>
        <h4>
          Are you sure you want to delete category
          <strong class="text-capitalize">
            "{{ selectedCategory?.claim_type }}" </strong
          >?
        </h4>

        <h3 class="font-size-18 font-weight-600 delete-text">
          This will also delete all associated sub-categories.
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deleteCategoryDialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          depressed
          color="red lighten-1 black--text"
          class="mx-2 custom-grey-border custom-bold-button"
          :loading="dataLoading"
          :disabled="dataLoading"
          v-on:click="confirmDelete"
        >
          Delete
        </v-btn>
      </template>
    </DeleteDialog>
  </v-container>
</template>

<script>
import {
  QUERY,
  POST,
  PATCH,
  DELETE,
} from "@/core/services/store/request.module";
import Dialog from "@/view/pages/partials/Dialog.vue";
import DeleteDialog from "@/view/pages/partials/Delete";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";

export default {
  mixins: [CommonMixin, ValidationMixin],
  components: { Dialog, DeleteDialog, ListingTable },
  data() {
    return {
      search: "",
      searchTimeout: null,
      subCategoryDialog: false,
      selectedCategory: null,
      subCategoryPayload: { name: "" },
      formErrors: {},
      subFormValid: false,
      categoryDialog: false,
      deletedSubCategories: [],
      deleteCategoryDialog: false,
      formValid: true,
      dataLoading: false,
      pageLoading: true,
      isEdit: false,
      totalPages: 0,
      totalRows: 0,
      rowsOffset: 0,
      itemsPerPage: 15,
      currentPage: 1,
      claimCategories: [],
      categoryPayload: {
        id: null,
        claim_type: "",
        max_amount: null,
        interval: "",
        color: "#000000",
        subcategories: [],
        approval_roles: [],
      },
      swatches: [
        ["#FF0000", "#AA0000", "#550000"],
        ["#FFFF00", "#AAAA00", "#555500"],
        ["#00FF00", "#00AA00", "#005500"],
        ["#00FFFF", "#00AAAA", "#005555"],
        ["#0000FF", "#0000AA", "#000055"],
      ],
      approvalRoles: [
        { id: 1, name: "Admin" },
        { id: 2, name: "Sales Person" },
        { id: 3, name: "Manager" },
        // { id: 4, name: "User" },
        { id: 4, name: "Employees" },
      ],
    };
  },

  mounted() {
    this.fetchCategories();
  },

  methods: {
    validateNumber($event) {
      this.limitDecimal($event, this.categoryPayload.max_amount);
      this.limitMaxLength($event, this.categoryPayload.max_amount, 12);
    },
    onSearch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.fetchCategories();
      }, 400);
    },
    openCategoryDialog() {
      this.isEdit = false;
      this.categoryPayload = {
        id: null,
        claim_type: "",
        max_amount: null,
        interval: "",
        color: "#000000",
        subcategories: [],
        approval_roles: [],
      };
      this.formErrors = {};
      this.categoryDialog = true;
    },
    editCategory(item) {
      this.isEdit = true;
      this.categoryPayload = {
        id: item.id,
        claim_type: item.claim_type,
        max_amount: item.max_amount,
        interval: item.interval,
        color: item.color,
        subcategories: item.subcategories
          ? JSON.parse(JSON.stringify(item.subcategories))
          : [],
        approval_roles: Array.isArray(item.approval_roles)
          ? item.approval_roles.map((r) =>
              typeof r === "object" ? Number(r.role_id) : Number(r)
            )
          : [],
      };
      this.formErrors = {};
      this.categoryDialog = true;
    },
    saveCategory() {
      this.$refs.categoryForm.validate();
      if (!this.formValid) return;

      this.dataLoading = true;
      const filteredSubcategories = (
        this.categoryPayload.subcategories || []
      ).filter((sub) => sub.name && sub.name.trim() !== "");
      const payload = {
        ...this.categoryPayload,
        subcategories: filteredSubcategories,
      };

      if (this.deletedSubCategories.length > 0)
        payload.deleted_subcategories = this.deletedSubCategories;

      const url = this.isEdit
        ? "claim-categories/update"
        : "claim-categories/create";
      const method = this.isEdit ? PATCH : POST;

      this.$store
        .dispatch(method, { url, data: payload })
        .then(() => {
          this.categoryDialog = false;
          this.deletedSubCategories = [];
          this.fetchCategories();
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    fetchCategories() {
      this.dataLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: "get/claim-categories",
          data: {
            search: this.search,
            current_page: this.currentPage,
            per_page: this.itemsPerPage,
            sort_column: "id",
            sort_order: "desc",
          },
        })
        .then(({ data }) => {
          this.claimCategories = data.rows || [];
          this.totalRows = data.total_rows || 0;
          this.rowsOffset =
            data.offset || (this.currentPage - 1) * this.itemsPerPage;
          this.itemsPerPage = data.per_page || this.itemsPerPage;
          this.totalPages =
            data.total_pages || Math.ceil(this.totalRows / this.itemsPerPage);
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },

    deleteCategory(item) {
      this.selectedCategory = item;
      this.related_id = item.id;
      this.deleteCategoryDialog = true;
    },
    confirmDelete() {
      this.dataLoading = true;
      this.$store
        .dispatch(DELETE, { url: `claim-categories/delete/${this.related_id}` })
        .then(() => {
          this.deleteCategoryDialog = false;
          this.fetchCategories();
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchCategories();
    },

    openSubCategoryPopup(category) {
      this.selectedCategory = category;
      if (!this.selectedCategory.subcategories)
        this.$set(this.selectedCategory, "subcategories", []);
      this.subCategoryPayload.name = "";
      this.subFormValid = false;
      this.subCategoryDialog = true;
    },
    saveSubCategory() {
      const isValid = this.$refs.subCategoryForm.validate();
      if (!isValid) return;
      this.dataLoading = true;
      this.$store
        .dispatch(POST, {
          url: "claim-subcategories/create",
          data: {
            category_id: this.selectedCategory.id,
            name: this.subCategoryPayload.name.trim(),
          },
        })
        .then((response) => {
          this.selectedCategory.subcategories =
            response.data.subcategories || [];
          this.subCategoryDialog = false;
          this.subCategoryPayload.name = "";
          this.fetchCategories();
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },

    removeSubCategory(index) {
      const sub = this.categoryPayload.subcategories[index];
      if (sub.id) this.deletedSubCategories.push(sub.id);
      this.categoryPayload.subcategories.splice(index, 1);
    },
    addSubCategoryField() {
      if (!this.categoryPayload.subcategories)
        this.$set(this.categoryPayload, "subcategories", []);
      this.categoryPayload.subcategories.push({ id: null, name: "" });
    },
    limitSubCategoryName(sub, value) {
      if (!sub) return;
      const trimmed = String(value ?? "").slice(0, 25);
      if (trimmed !== value) {
        sub.name = trimmed;
      }
    },
  },
};
</script>
<style scoped>
.color-indicator {
  width: 6px;
  height: 17px;
  min-width: 6px;
  border-radius: 6px;
  padding: 0;
}
</style>